import { Alert } from '@material-ui/lab';
import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import classes from './AuthForm.module.css';
import PasswordCriteriaHelper from 'components/Auth/PasswordCriteriaHelper/PasswordCriteriaHelper';
import Button from 'components/UI/Button/Button';
import CustomCheckbox from 'components/UI/CustomCheckbox/CustomCheckbox';
import Input from 'components/UI/Input/Input';
import * as actions from 'store/actions';

const AuthForm = (props) => {
  const [passwordRevealed, setPasswordRevealed] = useState(false);
  const recaptchaRef = useRef();
  const dispatch = useDispatch();
  const { signInError: error } = useSelector((state) => state.auth);

  useEffect(
    () => () => {
      dispatch(actions.clearAppError());
    },
    [dispatch],
  );

  const onReCapthaExpired = () => {
    recaptchaRef.current.reset();
  };

  let authRedirect = null;
  if (props.isAuthenticated) {
    authRedirect = <Redirect to={props.authRedirectPath} />;
  }

  const formElements =
    props.formType === 'SignUp'
      ? props.step === 1
        ? ['firstname', 'lastname', 'email']
        : ['password', 'passwordConfirmation']
      : ['email', 'password'];

  const form = formElements.map((formElement) => (
    <Input
      key={formElement}
      elementType={props.controls[formElement].elementType}
      elementConfig={props.controls[formElement].elementConfig}
      defaultValue={props.controls[formElement].value}
      value={props.controls[formElement].value}
      inputClassName="AuthInput"
      fontIcon={formElement === 'password' ? (passwordRevealed ? 'eye-slash' : 'eye') : null}
      iconClicked={formElement === 'password' ? () => setPasswordRevealed((prevState) => !prevState) : undefined}
      revealPassword={!!(formElement.includes('password') && passwordRevealed === true)}
      placeholder={props.controls[formElement].elementConfig.placeholder}
      invalid={
        props.controls[formElement].validation.required || (props.controls[formElement].value && props.controls[formElement].value.length > 0)
          ? !props.controls[formElement].valid && props.controls[formElement].touched
          : false
      }
      shouldValidate={props.controls[formElement].validation}
      validationError={props.controls[formElement].validation ? props.controls[formElement].validation.validationError : null}
      touched={props.controls[formElement].touched}
      changed={(event) => props.changed(event, formElement)}
      blurred={props.focusedOut ? (event) => props.focusedOut(event, formElement) : undefined}
    />
  ));

  // The dev recaptha key is a generic test key accessible to any developer for local testing
  const reCapthaKey = process.env.NODE_ENV === 'development' ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' : process.env.REACT_APP_RECAPTHA_KEY;

  return (
    <div className={classes.Auth}>
      {error && (
        <Alert severity="error" className={classes.ErrorMessage}>
          {error.replace(/_/g, ' ')}
        </Alert>
      )}
      {authRedirect}
      <form id="authform" className={classes.AuthForm} onSubmit={props.submit}>
        {form}
        {props.formType === 'SignUp' ? (
          props.step === 1 ? (
            <div>
              <div className={classes.ReCapthaContainer}>
                <ReCAPTCHA ref={recaptchaRef} theme="light" sitekey={reCapthaKey} onExpired={onReCapthaExpired} onChange={props.onReCapthaChange} />
              </div>
              <div className={classes.TermsAndPrivacyCheckContainer}>
                <CustomCheckbox type="Signup" checked={props.toggleTermsCheck} value={props.acceptTerms} />
                <p>
                  I accept Riza's{' '}
                  <a href="/privacy" className={classes.Link}>
                    Terms and Conditions
                  </a>{' '}
                  and I understand{' '}
                  <a href="/terms" className={classes.Link}>
                    Riza's Privacy Policy
                  </a>
                </p>
              </div>
            </div>
          ) : (
            <PasswordCriteriaHelper
              disabled={!props.controls.password.touched && !props.controls.passwordConfirmation.value}
              password={props.controls.password.value}
              passwordConfirmation={props.controls.passwordConfirmation.value}
              passwordConfirmationTouched={props.controls.passwordConfirmation.touched}
            />
          )
        ) : null}
        <Button btnType="Auth" disabled={props.disabled}>
          {props.buttonLabel}
        </Button>
      </form>
    </div>
  );
};

export default AuthForm;
